const { getCookie } = require('./cookie');
const search = require('./deep-search');

const getUserId = (alt = null) => {
  const melidataUserId = window.melidata_namespace
  && window.melidata_namespace.actual_track
  && window.melidata_namespace.actual_track.user
  && window.melidata_namespace.actual_track.user.user_id;

  const userId = getCookie('orguseridp', melidataUserId);
  return (userId && !Number.isNaN(parseInt(userId, 10))) ? parseInt(userId, 10) : alt;
};

const floxSearch = (floxResponse) => {
  if (!floxResponse) {
    return null;
  }

  const melidata = search(floxResponse, 'provider', 'melidata');
  const view = search(melidata, 'type', 'view').pop();

  return view ? view.path : null;
};

const getPath = () => {
  const trackPath = (window.melidata_namespace
    && window.melidata_namespace.actual_track
    && window.melidata_namespace.actual_track.path
  ) ? window.melidata_namespace.actual_track.path : null;

  if (trackPath) {
    return trackPath;
  }

  let floxPath = null;
  try {
    floxPath = floxSearch(window.__PRELOADED_STATE__.floxResponse);
  } catch (ex) { /* empty */ }

  const windowPathName = window.location.pathname || null;

  return floxPath || windowPathName;
};

module.exports = { getUserId, getPath };
